import listService from "api/listService";
import styles from "./styles.module.scss";
import { FC, Props } from "./typings";
import { useEffect, useMemo, useRef, useState } from "react";
import tagsService from "api/tagsService";
import statusService from "api/statusService";
import MessageCard from "components/MessageCard";
import { IPackage } from "dto/IPackage";
import { EOrder, ETypeOfOrder } from "components/SortOrder/typings";
import { useThreadStore } from "store/thread.store";

const ThreadList: FC<Props> = ({
  callClose,
  pack,
  toggle,
  isSelectable = false,
  selectMultiple = false,
  selectedElements = [],
  setSelectedElements = () => {},
  isIncoming,
}) => {
  const { data } = listService.useGetPackage(
    {
      ThreadId: pack.Thread!.Id!,
    },
    {
      type: ETypeOfOrder.SEND_DATE,
      order: EOrder.DESCENDING,
    }
  );

  const contentRef = useRef<HTMLDivElement>(null);

  const { data: tagsData } = tagsService.useGetTags();
  const { data: statusesData } = statusService.useGetStatuses();

  const statuses = useMemo(() => statusesData?.data ?? [], [statusesData]);
  const tags = useMemo(() => tagsData?.data ?? [], [tagsData]);

  const packs = useMemo(() => data?.data.Items ?? [], [data]);
  const keys = useMemo(() => data?.data.Keys ?? [], [data]);
  const { messages, setMessages } = useThreadStore();

  useEffect(() => {
    setMessages(pack.Thread.Id, packs);
  }, [packs]);

  console.log(messages);

  const [isOpen, setIsOpen] = useState(false);
  const [height, setHeight] = useState("0px");

  useEffect(() => {
    if (!callClose) return;
    setIsOpen(false);

    const timeout = setTimeout(() => {
      toggle();
    }, 400);

    return () => {
      clearTimeout(timeout);
    };
  }, [callClose]);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (!packs?.length || isOpen || callClose) return;
    toggleAccordion();
  }, [isOpen, packs]);

  useEffect(() => {
    console.log("Calculate thread height");
    if (!contentRef?.current) return;

    // Oblicz wysokość zawartości i ustaw ją w stanie
    setHeight(
      isOpen
        ? `${
            messages[pack.Thread.Id]?.filter(
              (p: IPackage) => p.Id !== pack.Id && !p.isDelete
            ).length * 70
          }px`
        : "0px"
    );
  });

  return (
    <div
      style={{ height }} // Ustaw wysokość na podstawie stanu
      ref={contentRef}
      className={styles.wrapper} // Klasa z CSS Transition
    >
      {messages[pack.Thread.Id]
        ?.filter((p: IPackage) => p.Id !== pack.Id && !p.isDelete)
        .map((pack: IPackage) => (
          <MessageCard
            onDownload={() => {}}
            onPreview={() => {}}
            keys={keys}
            selectedElements={selectedElements}
            setSelectedElements={setSelectedElements}
            msg={pack}
            statuses={statuses}
            tags={tags}
            selectMultiple={selectMultiple}
            showSomething={false}
            key={pack.Id}
            isThread={true}
            isSelectable={isSelectable}
            isIncoming={isIncoming}
          />
        ))}
    </div>
  );
};

export default ThreadList;
